import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnboarding } from '../context/OnboardingContext';
import logoGala from '../assets/common/LogoGala.png';
import ResendVerificationCode from '../components/ResendVerificationCode';
import { readPendingVerificationEmail } from '../utils/pendingVerification';
import { isMinorFromInput } from '../constants/legal';
import { CONTACT_EMAIL } from '../constants/site';
import './auth.css';

/**
 * Dernier écran de l'inscription : purement informatif.
 *
 * La saisie du code se fait sur /verification, atteinte via le lien du mail —
 * ce qui évite le cul-de-sac de l'ancien écran, inaccessible dès que l'onglet
 * était fermé (l'e-mail ne vivait que dans le state React).
 */
const OnboardingVerification = () => {
  const location = useLocation();
  const { formData } = useOnboarding();
  const email = formData.email || location.state?.email || readPendingVerificationEmail() || '';

  const [error, setError] = useState('');

  return (
    <div className="page">
      <div className="container">
        <div className="signup-logo">
          <img src={logoGala} alt="CycleGala" className="signup-logo-image" />
        </div>

        <h2 className="signup-brand">
          <span className="signup-brand--cycle">Cycle</span>
          <span className="signup-brand--gala">Gala</span>
        </h2>

        <div className="verify-icon" aria-hidden="true">📬</div>

        <h3 className="title">Vérifiez votre boîte mail</h3>

        <p className="subtitle">
          Un code à 6 chiffres a été envoyé à <strong>{email}</strong>.
        </p>
        <p className="subtitle">
          Pensez à regarder vos spams et courriers indésirables : c'est là que
          les premiers messages atterrissent le plus souvent.
        </p>
        <p className="subtitle">
          Ouvrez le mail puis cliquez sur <strong>« Saisir mon code »</strong> pour
          activer votre compte.
        </p>

        {isMinorFromInput(formData.birthDate) && (
          <div className="auth-notice">
            <p className="auth-notice__title">Une étape en plus pour les moins de 18 ans</p>
            <p className="auth-notice__text">
              Ton compte a besoin de l'autorisation de ton représentant légal avant de pouvoir
              être utilisé. Ton club te remettra le formulaire à faire signer, puis nous le
              transmettra.
            </p>
            <p className="auth-notice__text">
              Une fois l'autorisation reçue, ta connexion sera débloquée. Une question ?
              Écris-nous à <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
          </div>
        )}

        {error && <p className="auth-error">{error}</p>}

        <ResendVerificationCode email={email} onError={setError} />
      </div>
    </div>
  );
};

export default OnboardingVerification;
